import { render, staticRenderFns } from "./LatestProducts.vue?vue&type=template&id=1b71e25e&scoped=true"
import script from "./LatestProducts.vue?vue&type=script&lang=ts"
export * from "./LatestProducts.vue?vue&type=script&lang=ts"
import style0 from "./LatestProducts.vue?vue&type=style&index=0&id=1b71e25e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b71e25e",
  null
  
)

export default component.exports